import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import TotalIncomeCard from '../Skeleton/TotalIncomeCard';
import PropTypes from 'prop-types';
import MainCard from "../MainCard";
import NavigationBreadCrumbs from './NavigationBreadCrumbs';

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
}));

const BreadCrumbsBar = ({ isLoading, navigate }) => {
    const [steps, setSteps] = useState([{ 'title': 'Spend Details', 'name': 'servicedtl', 'path': '/service-details', 'current': true }])
    return (
        <>
            {isLoading ? (
                <TotalIncomeCard />
            ) : (
                <CardWrapper className="admin-topbar" border={false} content={false}>
                    <Box sx={{ p: 1, backgroundColor: '#f7f7f7' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} alignItems="left">
                                <NavigationBreadCrumbs steps={steps} navigate={navigate}></NavigationBreadCrumbs>
                            </Grid>

                        </Grid>
                    </Box>
                </CardWrapper>
            )}
        </>
    );
};

BreadCrumbsBar.propTypes = {
    isLoading: PropTypes.bool
};

export default BreadCrumbsBar;